<template>
  <div class="col-md-12" style="height:100%;padding-right: 0px;">
    <div class="col-md-12 pL0" style="height:85% !important;border-bottom:1px solid rgb(230, 230, 230);overflow-y: auto;overflow-x: hidden;">
      <h4 class="titles">Alerts</h4>
      <p style="padding-bottom:6px" class="ptext">Set up your preferences for the alerts/emails you want to receive.</p>
      <!-- <hr class="hr2"> -->

      <template v-for="(data , index) in AlertObject" v-if="selectedHireType == 'W2'">
        <h4 class="titles pB0 pT0" style="padding:10px 0px 0px 0px !important;"> {{getCorrectFormatAlertGroup(data.AlertGroup)}}</h4>
        <ob-collapse :type="8">

          <h4 v-if="data.AlertGroup == 'TimeSheets'"slot="collapse-title">Set up your preferences to receive the alerts/emails regarding {{getCorrectFormatAlertGroup(data.AlertGroup)}}.</h4>
          <h4 v-else slot="collapse-title">Set up your preferences to receive the alerts regarding {{getCorrectFormatAlertGroup(data.AlertGroup)}}.</h4>
          <div class="collpase_content" slot="collapse-details">
            <div class="checkbox-inline pL0">
             <template v-for="(preferenceType , Index) in data.AlertsPreference" v-if="preferenceType.AlertsPreferenceTypes != 'SignatureRequestReminder'">
                        <div class="col-md-12 pL0">
                          <div class="col-md-7 pL0 pR0">
                            <ob-toggle-checkbox :class="data.AlertGroup == 'EAD' ? 'eadClass': 'checkboxstyle'" v-model="preferenceType.IsEnable" :val="preferenceType.IsEnable" @change.native="onChangeToggle(preferenceType)">{{getPreferenceDisplayName(data.AlertGroup,preferenceType.AlertsPreferenceTypes)}}</ob-toggle-checkbox>
                          </div>
                           <div class="col-md-5">
                           <div v-if="data.AlertGroup == 'Others'" class="col-md-7">
                                <div class="othercheckbox">
                                <ob-checkbox :val="false" v-model="preferenceType.IsAlert" :disabled="disableCheckboxes(preferenceType)" @change.native="changeEnable(preferenceType)">Alerts</ob-checkbox>
                              </div>
                            </div>
                            <div v-else class="col-md-7">
                                <div class="checkbox-inline" :class="data.AlertGroup == 'FormI983' ? 'formI983Class' : 'eadcheckbox'">
                                <ob-checkbox :val="false" v-model="preferenceType.IsAlert" :disabled="disableCheckboxes(preferenceType)" @change.native="changeEnable(preferenceType)">Alerts</ob-checkbox>
                              </div>
                            </div>
                             <div class="col-md-5" v-if="data.AlertGroup == 'TimeSheets'">
                              <div class="checkbox-inline" style= "float:right;margin-top:-5px;margin-right:150px;">
                                <ob-checkbox :val="false" v-model="preferenceType.IsMail" :disabled="disableCheckboxes(preferenceType)" @change.native="changeEnable(preferenceType)">Emails</ob-checkbox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
            </div>
          </div>
        </ob-collapse>
        <hr v-if="data.AlertGroup != 'TimeSheets'" class="hr3">
      </template>
      <template v-for="(data , index) in AlertObject1099" v-if="selectedHireType == '1099'">
        <h4 class="titles pB0 pT0" style="padding:10px 0px 0px 0px !important;"> {{getCorrectFormatAlertGroup(data.AlertGroup)}}</h4>
        <ob-collapse :type="8">

          <h4 v-if="data.AlertGroup == 'TimeSheets'"slot="collapse-title">Set up your preferences to receive the alerts/emails regarding {{getCorrectFormatAlertGroup(data.AlertGroup)}}.</h4>
          <h4 v-else slot="collapse-title">Set up your preferences to receive the alerts regarding {{getCorrectFormatAlertGroup(data.AlertGroup)}}.</h4>
          <div class="collpase_content" slot="collapse-details">
            <div class="checkbox-inline pL0">
             <template v-for="(preferenceType , Index) in data.AlertsPreference" v-if="preferenceType.AlertsPreferenceTypes != 'SignatureRequestReminder'">
                        <div class="col-md-12 pL0">
                          <div class="col-md-7 pL0 pR0">
                            <ob-toggle-checkbox :class="data.AlertGroup == 'EAD' ? 'eadClass': 'checkboxstyle'" v-model="preferenceType.IsEnable" :val="preferenceType.IsEnable" @change.native="onChangeToggle(preferenceType)">{{getPreferenceDisplayName(data.AlertGroup,preferenceType.AlertsPreferenceTypes)}}</ob-toggle-checkbox>
                          </div>
                           <div class="col-md-5">
                           <div v-if="data.AlertGroup == 'Others'" class="col-md-7">
                                <div class="othercheckbox">
                                <ob-checkbox :val="false" v-model="preferenceType.IsAlert" :disabled="disableCheckboxes(preferenceType)" @change.native="changeEnable(preferenceType)">Alerts</ob-checkbox>
                              </div>
                            </div>
                            <div v-else class="col-md-7">
                                <div class="checkbox-inline" :class="data.AlertGroup == 'FormI983' ? 'formI983Class' : 'eadcheckbox'">
                                <ob-checkbox :val="false" v-model="preferenceType.IsAlert" :disabled="disableCheckboxes(preferenceType)" @change.native="changeEnable(preferenceType)">Alerts</ob-checkbox>
                              </div>
                            </div>
                             <div class="col-md-5" v-if="data.AlertGroup == 'TimeSheets'">
                              <div class="checkbox-inline" style= "float:right;margin-top:-5px;margin-right:150px;">
                                <ob-checkbox :val="false" v-model="preferenceType.IsMail" :disabled="disableCheckboxes(preferenceType)" @change.native="changeEnable(preferenceType)">Emails</ob-checkbox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
            </div>
          </div>
        </ob-collapse>
        <hr v-if="data.AlertGroup != 'TimeSheets'" class="hr3">
      </template>
        <template v-for="(data , index) in AlertObjectC2C" v-if="selectedHireType == 'C2C'">
        <h4 class="titles pB0 pT0" style="padding:10px 0px 0px 0px !important;"> {{getCorrectFormatAlertGroup(data.AlertGroup)}}</h4>
        <ob-collapse :type="8">

          <h4 v-if="data.AlertGroup == 'TimeSheets'" slot="collapse-title">Set up your preferences to receive the alerts/emails regarding {{getCorrectFormatAlertGroup(data.AlertGroup)}}.</h4>
          <h4 v-else slot="collapse-title">Set up your preferences to receive the alerts regarding {{getCorrectFormatAlertGroup(data.AlertGroup)}}.</h4>
          <div class="collpase_content" slot="collapse-details">
            <div class="checkbox-inline pL0">
             <template v-for="(preferenceType , Index) in data.AlertsPreference" v-if="preferenceType.AlertsPreferenceTypes != 'SignatureRequestReminder'">
                        <div class="col-md-12 pL0">
                          <div class="col-md-7 pL0 pR0">
                            <ob-toggle-checkbox :class="data.AlertGroup == 'EAD' || data.AlertGroup == 'W2C2CWorkAuthorization' ? 'eadClass': 'checkboxstyle'" v-model="preferenceType.IsEnable" :val="preferenceType.IsEnable" @change.native="onChangeToggle(preferenceType)">{{getPreferenceDisplayName(data.AlertGroup,preferenceType.AlertsPreferenceTypes)}}</ob-toggle-checkbox>
                          </div>
                           <div class="col-md-5">
                           <div v-if="data.AlertGroup == 'Others'" class="col-md-7">
                                <div class="othercheckbox">
                                <ob-checkbox :val="false" v-model="preferenceType.IsAlert" :disabled="disableCheckboxes(preferenceType)" @change.native="changeEnable(preferenceType)">Alerts</ob-checkbox>
                              </div>
                            </div>
                            <div v-else class="col-md-7">
                                <div class="checkbox-inline" :class="data.AlertGroup == 'FormI983' ? 'formI983Class' : 'eadcheckbox'">
                                <ob-checkbox :val="false" v-model="preferenceType.IsAlert" :disabled="disableCheckboxes(preferenceType)" @change.native="changeEnable(preferenceType)">Alerts</ob-checkbox>
                              </div>
                            </div>
                             <div class="col-md-5" v-if="data.AlertGroup == 'TimeSheets'">
                              <div class="checkbox-inline" style= "float:right;margin-top:-5px;margin-right:150px;">
                                <ob-checkbox :val="false" v-model="preferenceType.IsMail" :disabled="disableCheckboxes(preferenceType)" @change.native="changeEnable(preferenceType)">Emails</ob-checkbox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
            </div>
          </div>
        </ob-collapse>
        <hr v-if="data.AlertGroup != 'TimeSheets'" class="hr3">
      </template>
    </div>
    <div class="col-md-12 pL0">
      <ob-button type="primary" @click="addOrUpdateNotificationSetting()" style="margin-top: 16px;">Save</ob-button>
    </div>
  </div>
</template>
<script>
import { requiredIf } from 'vuelidate/lib/validators'
export default {
  data(){
    return {
       AlertObjectC2C:[
        {
          AlertGroup:'W2C2CWorkAuthorization',
          AlertsPreference:[],
        },
        {
          AlertGroup:'TimeSheets',
          AlertsPreference:[],
        },
        // {
        //   AlertGroup:'Others',
        //   AlertsPreference:[],
        // },
      ],
      AlertObject1099:[
        {
          AlertGroup:'W2C2CWorkAuthorization',
          AlertsPreference:[],
        },
        {
          AlertGroup:'TimeSheets',
          AlertsPreference:[],
        },
        // {
        //   AlertGroup:'Others',
        //   AlertsPreference:[],
        // },
      ],
      AlertObject:[
        {
          AlertGroup:'EAD',
          AlertsPreference:[],
        },
        {
          AlertGroup:'FormI983',
          AlertsPreference:[],
        },
        {
          AlertGroup:'TimeSheets',
          AlertsPreference:[],
        },
        // {
        //   AlertGroup:'Others',
        //   AlertsPreference:[],
        // },
      ],
      alertSettings:
        {
          AlertsPreference: "",
          IsEnable:true,
          IsMail:false,
          IsAlert:true
        }
    }
  },
  created(){
    this.getAlertSettings();
  },
  computed:{
     selectedHireType()
     {
       return this.loggedInUserObj.HireType
     }
  },

  methods:{
    onChangeToggle(val){
      if(val.IsEnable){
        val.IsAlert = true
        val.IsMail = false
      }else{
        val.IsAlert = false
        val.IsMail = false
      }
    },
    disableCheckboxes(val){
      if(!val.IsEnable){
        val.IsMail = false
        val.IsAlert = false
        return true
      }else{
        return false
      }
    },
    getPreferenceDisplayName(group , val){
      if(group == 'W2C2CWorkAuthorization' && val == 'WorkAuthExpiry')
      {
          return "About to Expire/ Expiring Documents"
      }
      else if(val == 'Pending'){
        return "Pending Action/Expired Documents"
      }else if(val == 'WorkAuthExpiry'){
        return "Expiring Work Authorization Documents"
      }else if(val == 'TimeSheetApporvalReminder'){
        return "Timesheet Approval Reminder"
      }else if(val == 'PasswordExpiry'){
        return "Password Expiring Reminder"
      }
      },
    changeEnable(val){
      if(!val.IsAlert && !val.IsMail){
        val.IsEnable = false
      }else{
        val.IsEnable = true
      }
    },

    getFormattedDate(data)
    {
      if(data.AlertSettings)
      {
        for(var i=0; i< this.AlertObject.length ; i++)
        {
          var alertPreference = data.AlertSettings.filter(x=>x.AlertGroup == this.AlertObject[i].AlertGroup);
          this.AlertObject[i].AlertsPreference = alertPreference;
        }
      }
      if(data.AlertSettingsC2C)
      {
        for (var i = 0; i < this.AlertObjectC2C.length; i++) {
            var alertPreferenceC2C = data.AlertSettingsC2C.filter((x) => x.AlertGroup == this.AlertObjectC2C[i].AlertGroup);
            if (alertPreferenceC2C.length > 0) {
                this.AlertObjectC2C[i].AlertsPreference = alertPreferenceC2C;
            }
        }
      }
      if(data.AlertSettings1099)
      {
        for (var i = 0; i < this.AlertObject1099.length; i++) {
            var alertPreference1099 = data.AlertSettings1099.filter((x) => x.AlertGroup == this.AlertObject1099[i].AlertGroup);
            if (alertPreference1099.length > 0) {
                this.AlertObject1099[i].AlertsPreference = alertPreference1099;
            }
        }
      }
    },
    addOrUpdateNotificationSetting(){
      this.$loading({'loadingText': 'Loading...'});

      var alertPreference = [];
      var alertPreferenceC2C = [];
      var alertPreference1099 = [];
      for (var i = 0;i < this.AlertObjectC2C.length; i++){
        for(var j = 0;j < this.AlertObjectC2C[i].AlertsPreference.length;j++){
          var pref = {
            AlertsPreferenceTypes:this.AlertObjectC2C[i].AlertsPreference[j].AlertsPreferenceTypes,
            IsEnable:this.AlertObjectC2C[i].AlertsPreference[j].IsEnable,
            IsAlert:this.AlertObjectC2C[i].AlertsPreference[j].IsAlert,
            IsMail:this.AlertObjectC2C[i].AlertsPreference[j].IsMail,
            AlertGroup:this.AlertObjectC2C[i].AlertGroup,
          }
          alertPreferenceC2C.push(pref)
        }
      }
      for (var i = 0;i < this.AlertObject1099.length; i++){
        for(var j = 0;j < this.AlertObject1099[i].AlertsPreference.length;j++){
          var pref = {
            AlertsPreferenceTypes:this.AlertObject1099[i].AlertsPreference[j].AlertsPreferenceTypes,
            IsEnable:this.AlertObject1099[i].AlertsPreference[j].IsEnable,
            IsAlert:this.AlertObject1099[i].AlertsPreference[j].IsAlert,
            IsMail:this.AlertObject1099[i].AlertsPreference[j].IsMail,
            AlertGroup:this.AlertObject1099[i].AlertGroup,
          }
          alertPreference1099.push(pref)
        }
      }
      for (var i = 0;i < this.AlertObject.length; i++){
        for(var j = 0;j < this.AlertObject[i].AlertsPreference.length;j++){
          var pref = {
            AlertsPreferenceTypes:this.AlertObject[i].AlertsPreference[j].AlertsPreferenceTypes,
            IsEnable:this.AlertObject[i].AlertsPreference[j].IsEnable,
            IsAlert:this.AlertObject[i].AlertsPreference[j].IsAlert,
            IsMail:this.AlertObject[i].AlertsPreference[j].IsMail,
            AlertGroup:this.AlertObject[i].AlertGroup,
          }
          alertPreference.push(pref)
        }
      }

      var Obj = {
         "AlertSettings":alertPreference,
          "AlertSettingsC2C": alertPreferenceC2C,
        "AlertSettings1099": alertPreference1099,
        "EmployeeId":this.loggedInUserObj.empId
      }
      ajax.post(`Employee/AlertSettings/AddOrUpdate`, Obj , (res) => {
      this.$loading({}).close()
      if(res.data.State == true){
        this.$message({
          type: 'success',
          message: 'Alert settings updated successfully'
        })
      }else{
        this.$message({
          type: 'error',
          message: res.data.Message
        })
        }
      })
    },
    getCorrectFormatAlertGroup(alertGroup){
      if(alertGroup == "Pending"){
        return "Timesheets"
      }
       else if(alertGroup == "FormI983"){
          return "Form I-983"
        }else if(alertGroup == "W2C2CWorkAuthorization"){
          return "Work Authorization Documents"
        }
         else{
          return alertGroup
        }
    },
    getAlertSettings(){
      this.$loading({'loadingText': 'Loading...'})
      ajax.get(`Employee/${this.loggedInUserObj.empId}/GetAlertSettings`, {} , (res) => {
        if(res.data.State == true){
            console.log(res)
           let result = res.data.OrganizationAlertSettings
           this.savedAlertSettings(result)
        }
        this.$loading({}).close()
      })
    },
     savedAlertSettings(result){
      if(result != null){
        this.alertSettings = result.AlertSettings
        this.getFormattedDate(result)
      }
     }
  }
}
</script>
<style lang="scss" scoped>

.titles {
  color: #143361;
  font-weight: 600;
  margin: 0;
  padding: 15px 0 18px;
}
.ptext {
  font-size: 12px;
  font-weight: 600;
  // border-bottom: 1px solid rgb(230, 230, 230);
}
.checkboxstyle {
  padding-bottom: 15px;
  width: 460px;
}
.eadClass
{
  width: auto
}
.formI983Class
{
 float:right;
 margin-top:-6px;
 margin-left:40px;
}
.eadcheckbox
{
  margin-left:-60px;
  margin-top:-4px;
  margin-bottom:15px;
}
.othercheckbox
{
 margin-left:54px;
  margin-top:-4px;
  margin-bottom:15px;
}
.collpase_content {
  padding-top: 20px;
}
hr.hr3 {
  margin-top:10px;
  border-top: 1px dashed #808080;
}
</styles>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSSettings/EmpAlertSettings.vue